import React from 'react'
import { Trash2 } from 'lucide-react'
import { Button } from '../ui/button'
import LoadingSpinner from './LoadingSpinner'

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  title = "Confirm Action",
  message,
  confirmText = "Confirm",
  confirmVariant = "destructive",
  icon: IconComponent = Trash2,
  iconColor = "text-error-600 dark:text-error-400",
  iconBgColor = "bg-error-100 dark:bg-error-900/20"
}) => {
  if (!isOpen) return null

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && !isLoading) {
      onClose()
    }
  }

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleBackdropClick}
    >
      <div className="modal-content bg-white dark:bg-[#221f2f] rounded-lg p-6 max-w-md w-full mx-4 border border-neutral-200 dark:border-[#2f2b41]">
        <div className={`flex items-center justify-center w-12 h-12 mx-auto mb-4 ${iconBgColor} rounded-full`}>
          <IconComponent className={`w-6 h-6 ${iconColor}`} />
        </div>
        
        <div className="text-center mb-6">
          <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100 mb-2">
            {title}
          </h3>
          <div className="text-neutral-600 dark:text-neutral-400">
            {message}
          </div>
        </div>
        
        <div className="flex gap-3 justify-end">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant={confirmVariant}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <LoadingSpinner size="sm" className="mr-2" />
                Processing...
              </>
            ) : (
              <>
                <IconComponent className="w-4 h-4 mr-2" />
                {confirmText}
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmationModal